import React, { useState, useEffect } from 'react';
import image01 from '../Assets/28.png';
import image02 from '../Assets/29.png';
import image03 from '../Assets/30.png';
import image04 from '../Assets/31.png';
import image05 from '../Assets/32.png';
import image06 from '../Assets/33.png';
import image07 from '../Assets/34.png';
// import image08 from '../Assets/08.png';
// import image09 from '../Assets/09.jpeg';
// import image10 from '../Assets/10.jpeg';
// import image11 from '../Assets/11.png';
// import image12 from '../Assets/12.jpeg';
// import image13 from '../Assets/13.jpeg';
// import image14 from '../Assets/14.jpeg';

const Testimonial = () => {
  const [imageIndex, setImageIndex] = useState(0);
  const [imageOpacity, setImageOpacity] = useState(1);
  const imageDetails = [
    "ARUN KUMAR R (2011-2015) - Technical Lead at Cognizant",
    "ROBIN R (2011-2015) - Senior macOS Developer & Lead at Zoho Corporation",
    "AMBIKA THYAGARAJAN (2005 - 2009) - Cisco Senior Software Engineer",
    "PAVITHRA SANTHOSH (2011 - 2015) - Principal Software Engineer at Fidelity Investments",
    "NIVETHA SWAMINATHAN (2013 - 2017) - Cyber Defense Analyst @Ford Motor Company",
    "GNANA PRASUNA (2015 - 2019) - Software Engineer II at American Express",
    "JOE AUSTIN (2015 - 2019) - Data Science Consultant  Tredence Inc.",
    "KEERTHANA G (2015 - 2019) - React Developer Prasad Corporation"
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setImageOpacity(0);
      setTimeout(() => {
        setImageIndex((prevIndex) => (prevIndex + 1) % 7);
        setImageOpacity(1);
      }, 1500);
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  const getImageName = (index) => {
    const images = [ image07,  image03, image04,  image01, image06, image05, image02];
    return images[index];
  };

  const containerStyle = {
    position:"relative",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height:'auto',
    marginTop: '5vh',
  };

  const imageStyle = {
    width: '50%', 
    height: 'auto',
    borderRadius: '10px',
    transition: 'opacity 1s ease-in-out', 
    opacity: imageOpacity, 
    marginTop: '5vh'
  };

  const detailsStyle = {
    position:"absolute",
    bottom:0,
    left:"25%",
    width:"50%",
    marginTop: '10px',
    backgroundColor:"black",
    color:"white",
    
    height:"5%"
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ fontSize: '3rem', marginTop: '7vh', background: 'linear-gradient(black, blue)',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent', }}>Proud Alumni</h2>
      <img
        src={getImageName(imageIndex)}
        alt={`Image ${imageIndex}`}
        style={imageStyle}
      />
      {/* <div style={detailsStyle}>
        <p style={{backgroundColor:"black",padding:"7px 7px",}}>{imageDetails[imageIndex]}</p>
      </div> */}
    </div>
  );
};

export default Testimonial;